import React from "react";
import {useRecoilState} from "recoil";
import {appState} from "../atoms/agreements/state";
import {URL_PARAMS} from "../constants/urlParams/urlParams";

export default function Initialize() {
  const [appStateValue, setAppStateValue] = useRecoilState(appState)

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("app_version") && appStateValue.app_version !== urlParams.get(URL_PARAMS.APP_VERSION)) {
    setAppStateValue({...appStateValue, "app_version": urlParams.get("app_version")})
  }

  return null;
}